<template>
<div class="pmtdiv">
    <linkbutton toplabel="Update Options" @click="Show()"  />

    <!--  MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <form ref="balform">
                
                <label class="titlelabel">{{name}}</label>
                <br/>
                <div class="midheight">
                    <optionbuttonmulti :itemList="optionList"  @select="selectoption" />
                </div>
                    
                
                
                
                <smallbutton  @click="go()" toplabel="Save" buttonclass="button buttonsave"/>
                <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Cancel"  buttonclass="button buttoncancel"/>
                <div>
                    <label class="responsemessage">{{responseMessage}}</label>
                </div>
            </form>
            
            
        </template>
      </actionmodal>
    </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields'
  import datamethods from '../../services/datamethods.js'
import smallbutton from '../controls/button.vue'
import linkbutton from '../controls/linkbutton.vue'
import actionmodal from '../controls/actionmodal.vue'
import optionbuttonmulti from '../controls/optionbuttonmulti.vue'
export default {
    name:'updateoptions',
    components:{
        smallbutton,
        actionmodal,
        linkbutton,
        optionbuttonmulti
    },
    props:{
      
        showButton:{
            type:Boolean,
            default:false
        },


        buttonClass:{
            type:String,
            default:'button buttonprimary bottom10'
        },
        product:{
            type:Object
        }
        
    },
    mixins:[datamethods],
    data(){
        return{
            trueParam:true,
            optionList:[]
        }
    },
    computed:{
        ...mapFields([
            'responseMessage',
            'pleaseWait',
            'ticket'

 
        ]),
        name(){
           return 'Select Options for product ' + this.product.name
        },
       
    },
    methods:{
        
       selectoption(id,name){
            this.optionList.forEach(myFunction2)
                function myFunction2(item, index, arr) {
                let inst=arr[index]
                if(inst.id==id){   
                    inst.selected=!inst.selected
                    inst.dirty=true
                } 
            }
       },
       
        Show(){
            this.getOptions()
            this.$refs.mymodal.openModal()

        },
        
        async go(){
            let req = {
                  productOptions:this.optionList
              }
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'updateproductproductoptions')

            if(response.Successful){
                this.$emit('refresh')
                this.$refs.mymodal.closeModal()
            
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
            
        },
        async getOptions(){
            let req = {
                  ID:this.product.id
              }
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'productoptions_includeall')

            if(response.Successful){
                this.optionList=response.productOptionList
            
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
       
        }
    },
    mounted(){
        
    }
}

</script>

<style>
.midheight{
    height:450px;
    overflow-x:hidden;
    overflow-y:auto;
}
</style>





























